import type { Locale } from './i18n';

/**
 * One rule for client and server (the mail callables in 1.15 check it too). Length beats
 * character classes: a long passphrase is safer and easier to type on a phone.
 */
export const PASSWORD_MIN = 8;
const PASSWORD_MAX = 128;

export const PASSWORD_TEXT = {
  de: {
    short: (min: string) => `Bitte mindestens ${min} Zeichen.`,
    long: (max: string) => `Bitte höchstens ${max} Zeichen.`,
    spaces: 'Bitte ohne Leerzeichen am Anfang oder Ende.',
  },
  en: {
    short: (min: string) => `Please use at least ${min} characters.`,
    long: (max: string) => `Please use at most ${max} characters.`,
    spaces: 'Please leave out spaces at the start or end.',
  },
} as const;

/** What is wrong with a new password, in plain words – or undefined if it is fine. */
export function passwordProblem(password: string, locale: Locale = 'de'): string | undefined {
  const t = PASSWORD_TEXT[locale];
  if (password.length < PASSWORD_MIN) return t.short(String(PASSWORD_MIN));
  if (password.length > PASSWORD_MAX) return t.long(String(PASSWORD_MAX));
  if (password.trim() !== password) return t.spaces;
  return undefined;
}
